package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeDisplay
import com.sddamico.swigmore.ds.typeMono
import com.sddamico.swigmore.ds.typeTeam
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Record Book tile: "Week 8 · OCT 23 · NO. 1 · <team> · 21 first-place votes · 227 pts". */
@Composable
fun WeekCard(week: Int, date: String, topTeam: String, note: String, modifier: Modifier = Modifier, onClick: (() -> Unit)? = null) {
  Card(modifier, variant = CardVariant.Ticket, onClick = onClick) {
    Div(attrs = Modifier.css("display" to "flex", "justify-content" to "space-between", "align-items" to "baseline").toAttrs()) {
      Span(attrs = Modifier.typeDisplay("26px", "normal").toAttrs()) { Text("Week $week") }
      Span(attrs = Modifier.typeMono().css("opacity" to ".7", "text-transform" to "uppercase").toAttrs()) { Text(date) }
    }
    Div(attrs = Modifier.typeCaps("9px", ".18em").css("margin-top" to "10px", "opacity" to ".7").toAttrs()) { Text("No. 1") }
    Div(attrs = Modifier.typeTeam("15px").css("margin-top" to "2px").toAttrs()) { Text(topTeam) }
    Div(attrs = Modifier.typeBody("12px", 500, "normal").css("opacity" to ".7", "margin-top" to "2px").toAttrs()) { Text(note) }
  }
}

